import React, { Component } from 'react'
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {injectIntl} from "react-intl";
import {Modal } from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import CreateFolderHeader from "./CreateFolderHeader";
import CreateFolderBody from "./CreateFolderBody";

class CreateFolderModal extends Component {
    render() {
        const {
            showCreateFolderModal,
            handleHiddenCreateFolderModal,
            bunkerEnabled,
            folderselect
        } = this.props;

        return (
            <Modal
                visible={showCreateFolderModal}
                width={400}
                onCancel={handleHiddenCreateFolderModal}
                footer={null}
                closeIcon={<img src={CloseIcon} alt={"icon close"} style = {{width: 25, height: 25}}/>}
                className='modal-parent'
                scrollableBody={true}
                destroyOnClose
            >   
                <CreateFolderHeader
                    bunkerEnabled={bunkerEnabled}
                />
                <CreateFolderBody
                    handleHiddenCreateFolderModal = {handleHiddenCreateFolderModal}
                    bunkerEnabled={bunkerEnabled}
                    folderselect={folderselect}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        
    }
  }

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateFolderModal)));
